// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_8y-6";
export var headerCell = "_8y-2";
export var rowWrapper = "_8y-4";
export var stickyAggregationRow = "_8y-7";
export var table = "_8y-1";
export var virtualRowWrapper = "_8y-5";
export var virtualTableContainer = "_8y-0";
export var white = "_8y-3";